import { ElementRef, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { PlatformService } from '../../services/platform/platform.service';
import { ConfigService } from '../../services/config/config.service';
import { SessionService } from '../../services/session/session.service';
import { MessageService } from '../../services/message/message.service';
import { Config } from '../../services/config/config';
import { Message } from '../../services/message/message';
import { Multilingual } from '../../models/multilingual';

export class UiComponent extends Multilingual {

  public scripts: any[] = new Array<any>();
  public loaded: boolean = false;
  public config: Config;
  public message: Message;
  public subscription: Subscription;
  public name: string;
  public elementRef: ElementRef;
  public router: Router;
  public route: ActivatedRoute;
  public configService: ConfigService;
  public sessionService: SessionService;
  public messageService: MessageService;
  public platform: PlatformService;

  constructor(
    injector: Injector
  ) {
    super(injector);
    this.elementRef = injector.get(ElementRef);
    this.router = injector.get(Router);
    this.route = injector.get(ActivatedRoute);
    this.configService = injector.get(ConfigService);
    this.sessionService = injector.get(SessionService);
    this.messageService = injector.get(MessageService);
    this.platform = injector.get(PlatformService);
    //this.name = name;
    this.config = this.configService.getConfig();

    this.subscription = this.messageService.getMessage()
      .subscribe(
      (message) => {
        if (message.parent != this.name) {
          //this[message.text]();
        }
      });

    this.sessionService.session.subscribe((session) => {
    }, (err) => { });
  }

  public afterSessionInit() {
  }

  public afterInitialize(): void {
  }

  public ngAfterViewInit() {
    for (let i = 0; i < this.scripts.length; i++) {
      this.loadScript(this.scripts[i].name);
    }
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setLoaded(loaded: boolean) {
    this.loaded = loaded;
  }

  getloaded() {
    return this.loaded;
  }

  protected loadScript(name: string): void {
    if (this.platform.isBrowser) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = name;
      s.async = false;
      this.elementRef.nativeElement.appendChild(s);
    }
  }

  protected sendMessage(text: string) {
    const message: Message = new Message();
    message.setText(text);
    message.setParent(this.name);
    this.messageService.sendMessage(message);
  }

}
